import { SUPER_TRIAL_TOKEN_KEY, getItemSafe } from './localStorage'

export function getSuperTrialToken() {
  return getItemSafe(SUPER_TRIAL_TOKEN_KEY)
}

export function setSuperTrialToken({
  search = window.location.search,
}: { search?: string } = {}) {
  const params = new URLSearchParams(search)
  const token = params.get('superTrialToken')
  if (!token) {
    return
  }
  localStorage.setItem(SUPER_TRIAL_TOKEN_KEY, token)
  return true
}
